import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
    Layout, Breadcrumb, Form, Input, message, Button, Spin, Descriptions, Tag, Table, Space, Typography, Divider, Popconfirm, Modal, InputNumber,
    Select, Checkbox, Switch
} from 'antd';
import { HomeOutlined, SaveOutlined, EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import CountryPhoneInput, { ConfigProvider } from 'antd-country-phone-input';
import en from 'world_countries_lists/data/en/world.json';
import ReactCountryFlag from "react-country-flag";
import CONSTANT from '../../config/constant';
import { shopInstance } from '../../config/api';

const getRandomuserParams = params => ({
    perPage: params.pagination.pageSize,
    page: params.pagination.current,
    ...params.options
});

const AgencyAddress = (props) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [visible, setVisible] = useState(false);
    const [modalTitle, setModalTitle] = useState('Thêm địa chỉ mới');
    const [agency, setAgency] = useState(null);
    const [listAddress, setListAddress] = useState([]);
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10
    })
    const user = JSON.parse(localStorage.getItem(CONSTANT.STORAGE_KEY_USER));

    // Address selection states
    const [provinces, setProvinces] = useState([]);
    const [districts, setDistricts] = useState([]);
    const [wards, setWards] = useState([]);
    const [selectedProvince, setSelectedProvince] = useState();
    const [selectedDistrict, setSelectedDistrict] = useState();
    const [selectedWard, setSelectedWard] = useState();
    const [loadingProvinces, setLoadingProvinces] = useState(false);
    const [loadingDistricts, setLoadingDistricts] = useState(false);
    const [loadingWards, setLoadingWards] = useState(false);
    const [storeId, setStoreId] = useState(null);
    const [phone, setPhone] = useState({
        short: 'VN',
        code: '84',
        phone: '', // Số điện thoại rỗng ban đầu
    });

    const columns = [
        {
            title: '#',
            key: 'name',
            render: (value, record, index) => {
                // Tính STT: (trang hiện tại - 1) * pageSize + index + 1
                return (pagination.current - 1) * pagination.pageSize + index + 1;
            },
        },
        {
            title: 'Họ tên',
            dataIndex: 'fullname',
            key: 'fullname'
        },
        {
            title: 'Số điện thoại',
            dataIndex: 'phone',
            key: 'phone',
        },
        {
            title: 'Địa chỉ',
            render: (_, record) => (

                <div>{`${record?.address_line}, ${record.ward?.name}, ${record.district?.name}, ${record.province?.name}`}</div>

            ),
        },
        {
            title: 'Vai trò',
            key: 'tags',
            render: (_, record) => (
                <>
                    {
                        record?.is_default && <Tag color="blue">Địa chỉ mặc định</Tag>
                    }
                    {
                        record?.is_pickup && <Tag color="green">Địa chỉ lấy hàng</Tag>
                    }
                    {
                        record?.is_return && <Tag color="volcano">Địa chỉ trả hàng</Tag>
                    }
                </>
            ),
        },
        {
            title: 'Trạng thái',
            key: 'active',
            render: (_, record) => (
                <>
                    {
                        record?.is_active ? <Tag color="blue">Kích hoạt</Tag> : <Tag>Không kích hoạt</Tag>
                    }
                </>
            ),
        },
        {
            title: '',
            key: 'action',
            render: (_, record) => (
                <Space size="middle">
                    <Typography.Link onClick={() => handleEdit(record)}>
                        <EditOutlined /> Sửa
                    </Typography.Link>
                    {
                        !record?.is_default && !record?.is_pickup && !record?.is_return &&
                        <>
                            <Divider type="vertical" />
                            <Popconfirm title={"Bạn có chắc là xóa?"} onConfirm={() => handleDelete(record._id)}>
                                <a><DeleteOutlined /> Xóa</a>
                            </Popconfirm>
                        </>
                    }

                </Space>
            ),
        },
    ];

    useEffect(() => {
        loadAgency();
    }, [user?._id]);

    // Load thong tin agency
    const loadAgency = async () => {
        setLoading(true);
        try {
            const res = await shopInstance.get(`${CONSTANT.API.AGENCY.AGENCY_INFO}/${user._id}`);
            if (res && res.data && res.code === 200) {
                setLoading(false);
                setAgency(res.data)
            }
        } catch (error) {
            message.warning('Lỗi lấy thông tin cửa hàng!', 2.5);
            setLoading(false);
        }
    }

    // Load danh sach dia chi cua agency
    const loadListAddress = async (params) => {
        let query = new URLSearchParams(getRandomuserParams(params)).toString();
        setLoading(true);
        try {
            const res = await shopInstance.get(`${CONSTANT.API.PRODUCT.ADDRESS_STORE_LIST}?${query}&agency=${agency?._id}`);
            if (res && res.data && res.code === 200) {
                setLoading(false);
                setListAddress(res?.data?.docs || []);
                setPagination({ ...params.pagination, total: res?.data?.total || 0 });
            }
        } catch (error) {
            message.warning('Lỗi lấy danh sách địa chỉ!', 2.5);
            setLoading(false);
        }
    }
    useEffect(() => {
        if (agency?._id)
            loadListAddress({ pagination });
    }, [agency?._id]);

    const handleTableChange = (pagination) => {
        loadListAddress({ pagination });
    }

    // API functions for address selection
    const getProvinces = async () => {
        try {
            setLoadingProvinces(true);
            const response = await shopInstance.get('/shop/address/get-provinces');
            if (response && response.data && response.code === 200) {
                setProvinces(response.data?.docs || []);
            }
        } catch (error) {
            console.error('Error fetching provinces:', error);
            message.error('Không thể tải danh sách tỉnh/thành phố');
        } finally {
            setLoadingProvinces(false);
        }
    };

    const getDistricts = async (provinceId) => {
        try {
            setLoadingDistricts(true);
            const response = await shopInstance.get('/shop/address/get-districts', {
                params: {
                    province: provinceId
                }
            });
            if (response && response.data && response.code === 200) {
                setDistricts(response.data?.docs || []);
            }
        } catch (error) {
            console.error('Error fetching districts:', error);
            message.error('Không thể tải danh sách quận/huyện');
        } finally {
            setLoadingDistricts(false);
        }
    };

    const getWards = async (districtId) => {
        try {
            setLoadingWards(true);
            const response = await shopInstance.get('/shop/address/get-wards', {
                params: {
                    district: districtId,
                }
            });
            if (response && response.data && response.code === 200) {
                setWards(response.data?.docs || []);
            }
        } catch (error) {
            console.error('Error fetching wards:', error);
            message.error('Không thể tải danh sách phường/xã');
        } finally {
            setLoadingWards(false);
        }
    };

    const handleProvinceChange = (value) => {
        setSelectedProvince(value);
        setSelectedDistrict(undefined);
        setSelectedWard(undefined);
        setDistricts([]);
        setWards([]);

        // Reset form values for district and ward
        form.setFieldsValue({
            district_id: undefined,
            ward_id: undefined
        });

        if (value) {
            getDistricts(value);
        }
    };

    const handleDistrictChange = (value) => {
        setSelectedDistrict(value);
        setSelectedWard(undefined);
        setWards([]);

        // Reset form value for ward
        form.setFieldsValue({
            ward_id: undefined
        });

        if (value) {
            getWards(value);
        }
    };

    const handleWardChange = (value) => {
        setSelectedWard(value);
    };

    // Chay ham load province
    useEffect(() => {
        getProvinces();
    }, []);

    // Sua dia chi
    const handleEdit = async (record) => {
        form.resetFields();
        setModalTitle('Sửa địa chỉ');
        setStoreId(record?._id);

        // Load thong tin district va ward
        if (record?.province?._id) {
            setSelectedProvince(record?.province?._id);
            getDistricts(record?.province?._id).then(() => {
                setSelectedDistrict(record?.district?._id);
                if (record?.district?._id) {
                    setSelectedWard(record?.ward?._id);
                    getWards(record?.district?._id);
                }
            })
        }
        // thiet lap gia tri cho form
        form.setFieldsValue({
            fullname: record.fullname,
            phone: record.phone,
            province: record.province?._id, district: record.district?._id, ward: record.ward?._id,
            address_line: record.address_line,
            is_default: record.is_default, is_active: record.is_active,
            is_pickup: record.is_pickup, is_return: record.is_return
        });
        if (record?.phone_parser)
            setPhone(record.phone_parser);
        setVisible(true);
    }

    // Xoa dia chi
    const handleDelete = async (key) => {
        if (key) {
            await shopInstance.delete(`${CONSTANT.API.PRODUCT.ADDRESS_STORE}/${key}`)
                .then((res) => {
                    if (res?.code === 200) {
                        message.success("Xóa thành công!");
                        let dataSource = [...listAddress];
                        setListAddress(dataSource.filter((item) => item._id !== key));
                    }
                    else {
                        message.error("Xóa không thành công!");
                    }
                })
                .catch(err => message.error("Xóa không thành công!"))
        }

    }

    // Xu ly luu dia chi
    const onFinish = async (values) => {
        values.agency = agency?._id;
        values.phone_parser = phone;
        // neu la them moi thi them moi
        if (!storeId) {
            await shopInstance.post(CONSTANT.API.PRODUCT.ADDRESS_STORE, values)
                .then(res => {
                    if (res && res.data && res.code === 200) {
                        message.success('Thêm điểm giao hàng thành công');
                        setVisible(false);
                        loadListAddress({ pagination });
                    }
                });
        }
        // nguoc lai sua dia chi
        else {
            try {
                await shopInstance.patch(`${CONSTANT.API.PRODUCT.ADDRESS_STORE}/${storeId}`, values, {
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    }
                })
                    .then(res => {
                        if (res && res.data && res.code === 200) {
                            message.success('Sửa thành công!');
                            setVisible(false);
                            loadListAddress({ pagination });
                        }
                        else {
                            message.error(res.message);
                        }
                    });
            }
            catch (error) {
                console.log(error)
            }

        }

    };

    return (
        <div>
            <Breadcrumb style={{ margin: '16px 0' }}>
                <Breadcrumb.Item >
                    <Link to="/"><HomeOutlined /></Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                    <Link to="/profile">Cài đặt cửa hàng</Link>
                </Breadcrumb.Item>
                <Breadcrumb.Item>
                    Địa chỉ vận chuyển
                </Breadcrumb.Item>
            </Breadcrumb>
            <Layout.Content className="layout-content">
                <Descriptions title="Địa chỉ">
                    <Descriptions.Item >Quản lý việc vận chuyển và địa chỉ giao hàng của bạn</Descriptions.Item>
                </Descriptions>
                <div>
                    <Button type="primary" icon={<PlusOutlined />} onClick={() => {
                        form.resetFields(); setModalTitle("Thêm địa chỉ mới"); setVisible(true)
                    }} style={{ float: 'right', marginBottom: 10 }}>
                        Thêm địa chỉ mới
                    </Button>
                </div>
                <Table columns={columns}
                    dataSource={listAddress}
                    loading={loading}
                    pagination={pagination}
                    onChange={handleTableChange}
                    rowKey={record => record._id}
                />
                <Modal
                    title={modalTitle}
                    centered
                    visible={visible}
                    okText={"Lưu"}
                    cancelText={"Hủy"}
                    onOk={() => form.submit()}
                    onCancel={() => setVisible(false)}
                    width={550}
                    maskClosable={false}
                >
                    <Form
                        form={form}
                        layout="vertical"
                        onFinishFailed={() => message.warning("Vui lòng nhập đầy đủ thông tin", 7)}
                        onFinish={onFinish}
                    // initialValues={{
                    //     phone: '', is_default: false, is_pickup: false, is_return: false, is_active: true
                    // }}
                    >

                        <Form.Item
                            label={"Họ và tên"}
                            name="fullname"
                            rules={[
                                { required: true, message: 'Họ và tên là bắt buộc' },
                            ]}
                            validateTrigger="onChange"  // check khi thay đổi
                        >
                            <Input min={0} placeholder={'Nhập vào'} style={{ width: '100%' }} />
                        </Form.Item>
                        <Form.Item label="Số điện thoại"
                            name="phone"
                            rules={[
                                { required: true, message: 'Số điện thoại là bắt buộc' }
                            ]}
                        >
                            <ConfigProvider
                                locale={en}
                                areaMapper={(area) => {
                                    return {
                                        ...area,
                                        emoji: <ReactCountryFlag svg countryCode={area.short} />,
                                    };
                                }}
                            >
                                <CountryPhoneInput
                                    value={phone}
                                    onChange={(v) => {
                                        setPhone(v);
                                        form.setFieldsValue({ phone: `${v.code}${v.phone}` }); // giữ nguyên object
                                    }}
                                />
                            </ConfigProvider>
                        </Form.Item>
                        {/* Address Selection */}
                        <Form.Item label="Tỉnh/Thành phố" name="province"
                            rules={[
                                { required: true, message: 'Vui lòng chọn tỉnh/thành phố!' }
                            ]}>
                            <Select
                                placeholder="Chọn tỉnh/thành phố"
                                loading={loadingProvinces}
                                onChange={handleProvinceChange}
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                {provinces.map((province, index) => (
                                    <Select.Option key={province._id + index} value={province._id}>
                                        {province.name}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item label="Quận/Huyện" name="district"
                            rules={[
                                { required: true, message: 'Vui lòng chọn quận/huyện!' }
                            ]}>
                            <Select
                                placeholder="Chọn quận/huyện"
                                loading={loadingDistricts}
                                onChange={handleDistrictChange}
                                disabled={!selectedProvince}
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                {districts.map((district, index) => (
                                    <Select.Option key={district._id + index} value={district._id}>
                                        {district.name}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>

                        <Form.Item label="Phường/Xã" name="ward"
                            rules={[
                                { required: true, message: 'Vui lòng chọn phường/xã!' }
                            ]}>
                            <Select
                                placeholder="Chọn phường/xã"
                                loading={loadingWards}
                                onChange={handleWardChange}
                                disabled={!selectedDistrict}
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                {wards.map((ward, index) => (
                                    <Select.Option key={ward._id + index} value={ward._id}>
                                        {ward.name}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                        <Form.Item
                            label={"Địa chỉ chi tiết"}
                            name="address_line"
                            rules={[
                                { required: true, message: 'Địa chỉ chi tiết là bắt buộc' },
                            ]}
                        >
                            <Input min={0} placeholder={'Số nhà, tên đường.v.v..'} style={{ width: '100%' }} />
                        </Form.Item>
                        <Form.Item
                            name="is_default"
                            valuePropName="checked"
                        >
                            <Checkbox>Đặt làm địa chỉ mặc định</Checkbox>
                        </Form.Item>
                        <Form.Item
                            name="is_pickup"
                            valuePropName="checked"
                        >
                            <Checkbox>Đặt làm địa chỉ lấy hàng</Checkbox>
                        </Form.Item>
                        <Form.Item
                            name="is_return"
                            valuePropName="checked"
                        >
                            <Checkbox>Đặt làm địa chỉ trả hàng</Checkbox>
                        </Form.Item>
                        <Form.Item
                            label="Trạng thái"
                            name="is_active"
                            valuePropName="checked"
                        >
                            <Switch checkedChildren="Kích hoạt" unCheckedChildren="Không kích hoạt" />
                        </Form.Item>
                    </Form>
                </Modal>
            </Layout.Content>
        </div>
    )

}
export default AgencyAddress;
